import React, { useEffect, useState } from 'react';
import { APIfacturas } from "../../../../services/api/facturas";


const FacturaViewer = ({ facturaId }) => {
  const [fileUrl, setFileUrl] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const url = await APIfacturas.viewFactura(facturaId);
        setFileUrl(url);
      } catch (error) {
        console.error('Error al obtener el documento de la factura:', error);
        // Manejar el error según tus necesidades
      }
    };

    fetchData();
  }, [facturaId]);

  if (!fileUrl) {
    return <p>Cargando...</p>;
  }

  return (
    <div>
      <iframe
        title="Factura PDF"
        width="100%"
        height="600"
        src={fileUrl}
        frameBorder="0"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default FacturaViewer;
